<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
  <div class="row w-100 justify-content-center">
    <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
      <div class="card message-signup-card shadow-lg border-0">
        <div class="card-body p-4 p-md-5">
          <!-- Header Section -->
          <div class="text-center mb-4">
            <div class="message-signup-icon mb-3">
              <i class="fa fa-check-circle fa-4x text-success"></i>
            </div>
            <h2 class="card-title fw-bold mb-2 text-success">{{ 'MESSAGE_SIGNUP.THANK_YOU_TITLE' | translate }}</h2>
            <p class="text-muted mb-0">{{ 'MESSAGE_SIGNUP.SUBTITLE' | translate }}</p>
          </div>

          <!-- Success Message Content -->
          <div class="message-content">
            <!-- Email Sent Alert -->
            <div class="alert alert-success bg-light-success border-0 mb-4" role="alert">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <i class="fa fa-envelope fa-2x text-success"></i>
                </div>
                <div class="flex-grow-1">
                  <h5 class="alert-heading mb-2">
                    <i class="fa fa-paper-plane me-2"></i>{{ 'MESSAGE_SIGNUP.EMAIL_SENT_TITLE' | translate }}
                  </h5>
                  <p class="mb-0">
                    {{ 'MESSAGE_SIGNUP.EMAIL_SENT' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Next Steps Alert -->
            <div class="alert alert-info bg-light-info border-0 mb-4" role="alert">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <i class="fa fa-info-circle fa-2x text-info"></i>
                </div>
                <div class="flex-grow-1">
                  <h5 class="alert-heading mb-2">
                    <i class="fa fa-mouse-pointer me-2"></i>{{ 'MESSAGE_SIGNUP.NEXT_STEPS_TITLE' | translate }}
                  </h5>
                  <p class="mb-0">
                    {{ 'MESSAGE_SIGNUP.CLICK_CONFIRMATION' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Email Issues Help -->
            <div class="alert alert-warning bg-light-warning border-0 mb-4" role="alert">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <i class="fa fa-exclamation-triangle fa-2x text-warning"></i>
                </div>
                <div class="flex-grow-1">
                  <h5 class="alert-heading mb-2">
                    <i class="fa fa-question-circle me-2"></i>{{ 'MESSAGE_SIGNUP.TROUBLE_TITLE' | translate }}
                  </h5>
                  <p class="mb-3">{{ 'MESSAGE_SIGNUP.TROUBLE_TEXT' | translate }}</p>
                  <div class="d-flex flex-wrap gap-2">
                    <!-- <button class="btn btn-outline-warning btn-sm">
                      <i class="fa fa-refresh me-1"></i>Resend Email
                    </button> -->
                    <a [routerLink]="['/contact-us']" class="btn btn-outline-info btn-sm">
                      <i class="fa fa-life-ring me-1"></i>{{ 'MESSAGE_SIGNUP.GET_HELP' | translate }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="text-center pt-3">
              <div class="row">
                <div class="col-12 col-md-6 mb-2 mb-md-0">
                  <a [routerLink]="['/login']" class="btn btn-primary btn-lg w-100">
                    <i class="fa fa-sign-in me-2"></i>{{ 'MESSAGE_SIGNUP.GO_TO_LOGIN' | translate }}
                  </a>
                </div>
                <div class="col-12 col-md-6">
                  <a [routerLink]="['/home']" class="btn btn-outline-secondary btn-lg w-100">
                    <i class="fa fa-home me-2"></i>{{ 'MESSAGE_SIGNUP.BACK_TO_HOME' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
  